export enum PermissionType {
  // User
  CanEverything = 1,

  // Organization
  CanManageOrganization = 2,
  CanManageMailAccounts = 3,
  CanManageUsers = 4,
  CanManageGroups = 5,

  // MailAccount
  CanManageMailAccount = 6,
  CanManageMailAccountUsers = 7,
  CanManageMailAccountDispatchingRules = 8,
  CanManageMailAccountTags = 9,
  CanManageMailAccountTemplates = 10,
  CanManageMailAccountFolders = 11,
  CanManageMailAccountContacts = 12,
  CanManageMailAccountCustomFolders = 13,
  CanManageMailAccountContactsImportExport = 14,

  // Searches
  CanSearchMailAccounts = 15,
  CanSearchUsers = 16,
  CanSearchGroups = 17,

  CanSearchMailAccountUsers = 18,
  CanSearchMailAccountDispatchingRules = 19,
  CanSearchMailAccountTags = 20,
  CanSearchMailAccountTemplates = 21,
  CanSearchMailAccountContacts = 22,

  // Email
  CanCreateEmail = 23,
  CanSendEmail = 24,
  CanValidateEmail = 25,
  CanRead = 26,
  CanReassign = 27,
  CanFinalDelete = 28,
}
